var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentMarks = function SvgPaymentMarks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 125 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1434CB",
    d: "M18.191 5.948c-.02 1.585 1.41 2.47 2.487 2.995 1.107.54 1.48.886 1.475 1.368-.009.739-.883 1.065-1.702 1.078-1.428.022-2.258-.387-2.918-.696l-.514 2.412c.662.306 1.888.572 3.16.584 2.985 0 4.938-1.476 4.948-3.765.012-2.904-4.01-3.065-3.983-4.363.01-.394.385-.814 1.206-.92.407-.055 1.53-.096 2.802.491l.5-2.333a7.6 7.6 0 0 0-2.66-.489c-2.809 0-4.785 1.497-4.801 3.638m12.262-3.436c-.546 0-1.005.318-1.21.807L24.98 13.517h2.983l.594-1.643H32.2l.345 1.643h2.629L32.88 2.512zm.417 2.973.86 4.132h-2.357zM14.575 2.512l-2.351 11.005h2.842l2.35-11.005zm-4.205 0-2.959 7.49-1.196-6.369c-.14-.711-.695-1.121-1.311-1.121H.068L0 2.83c.993.216 2.12.564 2.804.936.418.228.538.427.675.967l2.267 8.783H8.75l4.605-11.005z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M63.977 1.71H56.99v12.58h6.987z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M57.434 8.001a8 8 0 0 1 3.05-6.29 7.98 7.98 0 0 0-11.703 2.046 8.01 8.01 0 0 0 3.279 11.438 7.97 7.97 0 0 0 8.424-.905A7.98 7.98 0 0 1 57.434 8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M73.404 8.001a8 8 0 0 1-1.216 4.244 8 8 0 0 1-3.28 2.95 7.97 7.97 0 0 1-8.424-.906A8 8 0 0 0 63.534 8a8.01 8.01 0 0 0-3.05-6.29 7.977 7.977 0 0 1 11.704 2.045 8 8 0 0 1 1.216 4.244z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#payment-marks_svg__a)",
    d: "M120.97 2.31h-7.548c.439 2.497 2.858 4.846 5.496 4.846h6.009c.073-.22.073-.588.073-.808 0-2.202-1.832-4.037-4.03-4.037"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4FAD50",
    d: "M114.081 7.596v6.093h3.664v-3.23h3.225c1.758 0 3.297-1.248 3.81-2.863zM101.184 2.31v11.306h3.225s.806 0 1.245-.808c2.199-4.33 2.858-5.652 2.858-5.652h.44v6.46h3.664V2.31h-3.224s-.806.073-1.246.807c-1.832 3.744-2.858 5.653-2.858 5.653h-.44V2.31zM85.795 13.69V2.385h3.664s1.026 0 1.612 1.615c1.466 4.257 1.613 4.845 1.613 4.845S92.977 7.817 94.296 4c.586-1.615 1.612-1.615 1.612-1.615h3.664V13.69h-3.664V7.597h-.44l-2.052 6.093h-1.612l-2.052-6.093h-.44v6.093z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "payment-marks_svg__a",
    x1: 113.245,
    x2: 124.603,
    y1: 5.155,
    y2: 5.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088CCB"
  })))));
};
export default SvgPaymentMarks;